import PropTypes from "prop-types";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Box, Button, Flex } from "rebass";
import ChecvronDown from "../../icons/ChevronDown";
import { getLocalizedString } from "../../utils";
import { MdBlock, MdClear, MdOutlineWarningAmber } from "react-icons/md";
import useResponsive from "../../hooks/useResponsive";
import { CiLock } from "react-icons/ci";
import BasicPopover from "../common/BasicPopover";

const statusColors = {
  Warning: "#E2BA16",
  Bloccante: "#F85959",
};

function Client({
  id,
  name,
  code,
  email,
  phone,
  city,
  address,
  zipCode,
  channelDescription,
  keyIndex,
  reasonBlock,
  reorder,
}) {
  const navigate = useHistory();
  const [hideData, setHideData] = useState(true);
  const [displayStatusDetails, setDisplayStatusDetails] = useState(false);
  const [newOrderForbiddenPopoverOpen, setNewOrderForbiddenPopoverOpen] =
    useState(false);

  const { isMobile, type } = useResponsive();

  const enableStatusDisplay =
    channelDescription === "Bloccante" || channelDescription === "Warning";

  const isReorderEnabled = reorder === 1;

  const { statusCode, statusDescription, statusMessage } = reasonBlock || {
    statusCode: "",
    statusDescription: "",
    statusMessage: "",
  };

  const handleStatusEnter = () => {
    if (type.desktop && enableStatusDisplay)
      setTimeout(() => {
        setDisplayStatusDetails(true);
      }, 200);
  };
  const handleStatusLeave = () => {
    if (type.desktop && enableStatusDisplay)
      setTimeout(() => {
        setDisplayStatusDetails(false);
      }, 200);
  };

  const statusIcon = () => {
    const statusDic = {
      Warning: <MdOutlineWarningAmber color="white" size={20} />,
      Bloccante: <MdBlock color="white" size={20} />,
    };
    return statusDic[channelDescription] || null;
  };
  return (
    <Flex width={1} mb={3} key={keyIndex} fontSize="0.9em">
      <Flex
        width={1}
        flexDirection={"row"}
        color={displayStatusDetails ? "#fff" : "unset"}
      >
        <Flex
          backgroundColor={statusColors[channelDescription] || "#f5f5f5"}
          justifyContent={"center"}
          alignItems={["flex-start", "center"]}
          width={"24px"}
          mr={[1, 2]}
          py={["12px", 0]}
          onMouseEnter={handleStatusEnter}
          onMouseLeave={handleStatusLeave}
          onClick={() => {
            if (!type.desktop && enableStatusDisplay) {
              setDisplayStatusDetails(!displayStatusDetails);
              setHideData(true);
            }
          }}
          sx={{
            ...(enableStatusDisplay && {
              cursor: "help",
            }),
          }}
        >
          {!!statusIcon() && !type.desktop && displayStatusDetails ? (
            <MdClear color="white" size={20} />
          ) : (
            statusIcon()
          )}
        </Flex>
        <Flex flexDirection={["column", "row"]} key="content" width={1}>
          <Flex
            width={1}
            justifyContent={["flex-start", "space-evenly"]}
            alignItems="left"
            p={["12px", 3]}
            key="contents"
            flexDirection={["column", "row"]}
            bg={
              displayStatusDetails
                ? statusColors[channelDescription] || "#f5f5f5"
                : "#f5f5f5"
            }
            minHeight={["unset", "142px"]}
          >
            <Flex
              flex={"1 0 calc(100% / 3)"}
              height="100%"
              flexDirection="column"
              justifyContent="space"
              paddingRight={[0, "8px"]}
              sx={{
                borderRight: [
                  "none",
                  `1px solid ${displayStatusDetails ? "white" : "transparent"}`,
                ],
                borderBottom: [
                  `1px solid ${displayStatusDetails ? "white" : "transparent"}`,
                  "none",
                ],
                "& > div": {
                  marginBottom: ["0px", "15px", "15px"],
                },
              }}
            >
              <Flex flexDirection="row" justifyContent="space-between">
                <span style={{ fontWeight: "bold" }}>{name}</span>
                <Flex
                  onClick={() => setHideData(!hideData)}
                  display={["block", "none"]}
                  sx={{
                    visibility: displayStatusDetails ? "hidden" : "visible",
                    pointerEvents: displayStatusDetails ? "none" : "default",
                  }}
                >
                  <ChecvronDown
                    style={{
                      ...(hideData && { transform: "rotate(180deg)" }),
                      width: "18px",
                      height: "18px",
                    }}
                  />
                </Flex>
              </Flex>
              <Box
                sx={{
                  display:
                    displayStatusDetails && isMobile ? "none" : "initial",
                }}
              >
                <span>{getLocalizedString("Client code")}:</span>
                <strong style={{ marginLeft: "10px" }}>
                  {code.toLowerCase()}
                </strong>
              </Box>
            </Flex>

            {displayStatusDetails ? (
              <Flex
                flex={"1 0 calc(200% / 3)"}
                height="100%"
                ml={[0, "8px"]}
                mt={["8px", 0]}
              >
                <Flex width="100%" height="100%" justifyContent={"flex-start"}>
                  {!isMobile && statusIcon()}
                  <Flex flexDirection={"column"} ml={[0, "8px"]}>
                    <Box fontWeight={600}>
                      {statusCode && statusDescription
                        ? `${statusCode} - ${statusDescription.toLowerCase()}`
                        : statusCode || "-"}
                    </Box>
                    <Box>{statusMessage}</Box>
                  </Flex>
                </Flex>
              </Flex>
            ) : (
              <Flex
                flex={"1 0 calc(200% / 3)"}
                height="100%"
                ml={[0, "8px"]}
                mt={["8px", 0]}
              >
                <Flex
                  flex={1}
                  pr={2}
                  height="100%"
                  flexDirection="column"
                  justifyContent="flex-start"
                  sx={{
                    "& > div": {
                      marginBottom: ["0px", "15px", "15px"],
                    },
                  }}
                >
                  <Box style={{ wordWrap: "break-word" }}>
                    <span>{email?.toLowerCase()}</span>
                  </Box>
                  <Box
                    display={[hideData ? "none" : "block", "block", "block"]}
                  >
                    {getLocalizedString("Telefono")}:
                    <span style={{ marginLeft: "10px" }}>
                      {phone?.toLowerCase()}
                    </span>
                  </Box>
                </Flex>
                <Flex
                  flex={1}
                  height="100%"
                  flexDirection="column"
                  justifyContent="flex-start"
                  sx={{
                    "& > div": {
                      marginBottom: ["0px", "15px", "15px"],
                    },
                  }}
                >
                  <Box
                    display={[hideData ? "none" : "block", "block", "block"]}
                  >
                    <span>{getLocalizedString("Città")}:</span>
                    <span style={{ marginLeft: "10px" }}>
                      {city?.toLowerCase()}
                    </span>
                  </Box>
                  <Box
                    display={[hideData ? "none" : "block", "block", "block"]}
                  >
                    <span>{getLocalizedString("Indirizzo")}:</span>
                    <span style={{ marginLeft: "10px" }}>
                      {address?.toLowerCase()}
                    </span>
                  </Box>
                  <Box
                    display={[hideData ? "none" : "block", "block", "block"]}
                  >
                    <span>{getLocalizedString("CAP")}:</span>{" "}
                    <span style={{ marginLeft: "10px" }}>
                      {zipCode?.toLowerCase()}
                    </span>
                  </Box>
                </Flex>
              </Flex>
            )}
          </Flex>
          <Flex
            width={[1, 300]}
            bg={[
              displayStatusDetails
                ? statusColors[channelDescription] || "#f5f5f5"
                : "#232323",
              "#232323",
            ]}
            sx={{
              minHeight: ["unset", 100, 100],
            }}
            p={["10px 2%", 3]}
            flexDirection={["row", "column"]}
            alignItems="flex-start"
            justifyContent="space-around"
            key="buttons"
            ml={[null, 2]}
          >
            <Flex
              justifyContent="center"
              alignItems="center"
              key="new"
              mr={[2, 0]}
              minHeight={30}
              minWidth={["47%", "100%"]}
            >
              {channelDescription != "Bloccante" && (
                <Box sx={{ position: "relative", width: "100%" }}>
                  <Button
                    variant="primary"
                    height={["38px", null]}
                    sx={{
                      fontFamily: "Open Sans",
                      fontSize: "0.8em",
                      fontWeigth: 800,
                      color: "#000",
                      width: "100%",
                      background: "#fff",
                      textTransform: "uppercase",
                      cursor: "pointer",
                      pointerEvents: isReorderEnabled ? "default" : "none",
                      "&:hover": {
                        backgroundColor: "#909090",
                        color: "white",
                      },
                      ...(!isReorderEnabled && {
                        opacity: 0.8,
                      }),
                    }}
                    onClick={() => {
                      localStorage.setItem("selectedCustomer", id);
                      navigate.push("/newOrder/" + id);
                    }}
                  >
                    {getLocalizedString("Nuovo Ordine")}
                  </Button>
                  {!isReorderEnabled && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: "9px",
                        right: "5px",
                      }}
                    >
                      <BasicPopover
                        isOpen={newOrderForbiddenPopoverOpen}
                        content={
                          <Box>
                            {getLocalizedString(
                              "CUSTOMERS_NEW_ORDER_FORBIDDEN",
                            )}
                            <ul>
                              <li>
                                -&nbsp;
                                {getLocalizedString(
                                  "CUSTOMERS_NEW_ORDER_FORBIDDEN_2",
                                )}
                              </li>
                              <li>
                                -&nbsp;
                                {getLocalizedString(
                                  "CUSTOMERS_NEW_ORDER_FORBIDDEN_3",
                                )}
                              </li>
                            </ul>
                          </Box>
                        }
                      >
                        <Box
                          sx={{
                            cursor: "help",
                            pointerEvents: "auto",
                            padding: "1px",
                            borderRadius: "25%",
                            "&:hover": {
                              background: "rgba(27, 27, 27, 0.1)",
                            },
                          }}
                          onMouseEnter={() => {
                            setTimeout(
                              () => setNewOrderForbiddenPopoverOpen(true),
                              400,
                            );
                          }}
                          onMouseLeave={() => {
                            setTimeout(
                              () => setNewOrderForbiddenPopoverOpen(false),
                              400,
                            );
                          }}
                        >
                          <CiLock
                            size={20}
                            color={displayStatusDetails ? "#272727" : "unset"}
                          />
                        </Box>
                      </BasicPopover>
                    </Box>
                  )}
                </Box>
              )}
            </Flex>

            <Flex
              justifyContent="center"
              alignItems="center"
              key="view"
              minWidth={["47%", "100%"]}
            >
              <Button
                variant="primary"
                height={["38px", null]}
                sx={{
                  width: "100%",
                  color: "#FFF",
                  fontFamily: "Open Sans",
                  fontSize: "0.8em",
                  fontWeigth: 800,
                  backgroundColor: "rgb(35, 35, 35)",
                  border: "1px solid #FFF",
                  textTransform: "uppercase",
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor: "#909090",
                    border: "1px solid #909090",
                    color: "white",
                  },
                }}
                onClick={() => {
                  localStorage.setItem("selectedCustomer", id);
                  navigate.push("/orders/" + id);
                }}
              >
                {getLocalizedString("Visualizza ordini")}
              </Button>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
}

Client.propTypes = {
  name: PropTypes.string,
  clientCode: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  city: PropTypes.string,
  address: PropTypes.string,
  zip: PropTypes.string,
  channelDescription: PropTypes.oneOf([
    "Non Bloccante",
    "Bloccante",
    "blocked",
    "Warning",
  ]),
  keyIndex: PropTypes.string,
};

export default Client;
